import React, { useMemo } from "react";
import {
  Card,
  DataTable,
  BlockStack,
  Badge,
  TextField,
} from "@shopify/polaris";

const CouponCardTable = ({
  products,
  indexing = 1,
  perPage,
  search,
  setSearch,
}) => {
  const filteredProduct = useMemo(() => {
    if (!search?.trim()) return products;
    return products.filter((item) =>
      item?.coupon?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [products, search]);

  const rows =
    filteredProduct?.map((item, index) => [
      index + 1 + (indexing - 1) * perPage,
      item.coupon || "—",
      item.used ? (
        <Badge tone="critical">Used</Badge>
      ) : (
        <Badge tone="success">Unused</Badge>
      ),
      item.createdAt ? new Date(item.createdAt).toLocaleDateString() : "—",
    ]) || [];

  const headings = ["SN", "Coupon", "Status", "Date"];

  return (
    <Card>
      <BlockStack gap="400">
        <TextField
          label="Search Coupon Card"
          value={search}
          onChange={setSearch}
          autoComplete="off"
          placeholder="Enter coupon card..."
        />

        <DataTable
          columnContentTypes={headings.map((r) =>
            r === "SN" ? "numeric" : "text",
          )}
          headings={headings}
          rows={rows}
        />
      </BlockStack>
    </Card>
  );
};

export default CouponCardTable;